
import { createApiClient } from 'Network/ApiClient';

export const BenefitGroupAxiosInstance = createApiClient('BenefitGroup/');


